import { useState } from "react"
import { toast } from "react-toastify"
import axiosInstance from "../../../services/axios-client"

const useRemarkSettings = () => {
    const [projectID, setProjectId] = useState('')
    const [isSaving, setIsSaving] = useState(false)
    const [remarks, setRemarks] = useState([
        {
            ProjectID: projectID,
        }
    ])
    const [deleted, setDeleted] = useState([])
    const [projectPhases, setProjectPhases] = useState([])

    const addNewRemarks = () => {
        let data = [...remarks]
        data.push({
            ProjectID: projectID
        })
        setRemarks(data)
    }

    const handleSelectJustificationType = (value, index) => {
        let data = [...remarks]
        data[index]['JustificationType'] = value
        setRemarks(data)
    }

    const handleSelectScoringType = (value, index) => {
        let data = [...remarks]
        data[index].ScoringType = value
        setRemarks(data)
    }

    const handleSelectLevel = (value, index) => {
        let data = [...remarks]
        data[index].Level = value
        setRemarks(data)
    }

    const handleSelectFrom = (value, index) => {
        let data = [...remarks]
        data[index].From = value
        setRemarks(data)
    }

    const handleSelectTo = (value, index) => {
        let data = [...remarks]
        data[index].To = value
        setRemarks(data)
    }

    const handleSelectProjectPhase = (value, index) => {
        let data = [...remarks]
        data[index].From = value
        setRemarks(data)
    }

    const deleteThisRemark = (removedIndex, remarkID) => {
        let filtered
        if (remarkID) {
            filtered = remarks.filter((remark) => remark.ID !== remarkID)
            let deleted_data = [...deleted]
            deleted_data.push(remarkID)
            setDeleted(deleted_data)
        } else {
            filtered = remarks.filter((_, index) => {
                return index !== removedIndex
            })
        }
        setRemarks(filtered)
    }

    const getRemarksByProject = async (id) => {
        try {
            let res = await axiosInstance.get(`/auth/remark-settings/${id}`)
            if (res.status === 200) {
                if (res.data.data.length > 0) {
                    // Parse semicolon-separated From field (for maximum type with project phases) into array
                    const parsedRemarks = res.data.data.map(remark => {
                        if (remark.JustificationType === 'maximum' && remark.From) {
                            // Handle both string (UUID or semicolon-separated UUIDs) and array formats
                            if (typeof remark.From === 'string') {
                                const parsed = remark.From.includes(';')
                                    ? remark.From.split(';').map(id => id.trim())
                                    : [remark.From.trim()]
                                return {
                                    ...remark,
                                    From: parsed
                                }
                            } else if (Array.isArray(remark.From)) {
                                return remark
                            }
                        }
                        return remark
                    })
                    setRemarks(parsedRemarks)
                }
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }

        }
    }

    const postRemarksByProject = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let bool = false
            let data = [...remarks]
            // Convert From array to semicolon-separated string for maximum type
            const formattedData = data.map(remark => {
                if (remark.JustificationType === 'maximum' && Array.isArray(remark.From)) {
                    return {
                        ...remark,
                        From: remark.From.join(';')
                    }
                }
                return remark
            })

            for (const remark of formattedData) {
                if (remark.Level || (remark.From && remark.To)) {
                    remark.ProjectID = projectID
                    bool = true
                } else {
                    bool = false
                }
            }
            if (bool) {
                let res = await axiosInstance.post('/auth/remark-settings/project', formattedData)
                if (res.status === 200) {
                    toast.success("Success Set Project's Remarks")
                    return true
                }
            } else {
                toast.error("All field should be filled")
                return false
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
            return false
        } finally {
            setIsSaving(false)
        }
    }

    const deleteRemarksByProject = async (e) => {
        e.preventDefault()
        try {
            if (deleted.length > 0) {
                let res = await axiosInstance.post('/auth/remark-settings/delete', { IDs: deleted })
                if (res.status === 204) {
                    toast.success("Success Delete Project's Remarks")
                    return true
                }
                return false
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
            return false
        }
    }

    const getProjectPhase = async (projectID) => {
        try {
            let res = await axiosInstance.get(`auth/projects/project-phase?projectID=${projectID}`)
            if (res.status === 200) {
                setProjectPhases(res.data.data)
                return true
            }
        } catch (error) {
            console.log(error)

            return false
        }
    }

    return {
        getRemarksByProject,
        setProjectId,
        remarks,
        addNewRemarks,
        deleteThisRemark,
        deleted,
        handleSelectJustificationType,
        handleSelectScoringType,
        handleSelectLevel,
        handleSelectFrom,
        handleSelectTo,
        postRemarksByProject,
        deleteRemarksByProject,
        getProjectPhase,
        handleSelectProjectPhase,
        isSaving,
        projectPhases
    }
}

export default useRemarkSettings